import React, { Component } from "react";

class LineBar extends Component {
  render() {
    return (
      <p
        style={{
          width: "259px",
          height: "0px",
          marginLeft: "17px",
          marginTop: "21px",
          color: "#C2C0BD",
          borderStyle: "solid",
          borderWidth: "0.5px"
        }}
      />
    );
  }
}

export default LineBar;
